"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../index.scss");
const mobx_react_1 = require("mobx-react");
const WorkResultsTable_1 = __importDefault(require("@Components/WorkItemV2/WorkResultsTable"));
const fetch_type_enum_1 = require("@Components/WorkItemV2/fetch-type-enum");
const HistoryCompactWorkItem_1 = __importDefault(require("@Components/WorkItemV2/History/HistoryCompactWorkItem"));
const HistoryExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/History/HistoryExtendedWorkItem"));
const contexts_1 = require("@App/contexts");
const registration_history_tab_name_1 = require("@App/enum/registration-history-tab-name");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const SearchWithCriteria_1 = __importDefault(require("@Components/Search/SearchWithCriteria"));
const reg_history_tab_names_to_source_1 = require("@App/helpers/reg-history-tab-names-to-source");
const registration_history_tab_store_1 = require("@App/stores/rightsholder/registrationHistory/registration-history-tab-store");
const lodash_1 = require("lodash");
const registration_status_1 = require("@App/enum/registration-status");
const reg_history_filter_1 = require("@App/forms/filters/reg-history-filter");
const RegistrationHistoryTab = (props) => {
    var _a;
    const { userStore, registrationHistoryStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { type, registrationHistoryTabStore } = props;
    const useFilters = type === registration_history_tab_name_1.RegistrationHistoryTabName.Completed;
    const handleSearch = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (pagination = registration_history_tab_store_1.defaultBebopPagination) {
        setLoading(true);
        const registrationStatus = (0, reg_history_tab_names_to_source_1.regHistoryTabNamesAsRegistrationStatus)(type);
        yield registrationHistoryTabStore.searchRegistrationHistory(registrationStatus !== null && registrationStatus !== void 0 ? registrationStatus : registration_status_1.RegistrationStatus.pending, pagination, useFilters && registrationHistoryStore.currentFilters);
        setLoading(false);
    });
    const onChangeLimit = (newLimit) => __awaiter(void 0, void 0, void 0, function* () {
        registrationHistoryTabStore.setLimit(newLimit);
        yield handleSearch(registrationHistoryTabStore.pagination);
    });
    const onChangePage = (newPage) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        registrationHistoryTabStore.setCurrentPage((_a = newPage.page) !== null && _a !== void 0 ? _a : 1);
        yield handleSearch(registrationHistoryTabStore.pagination);
    });
    const handleSearchWithNewCriteria = (searchCriteria) => __awaiter(void 0, void 0, void 0, function* () {
        registrationHistoryStore.setCurrentQuery(searchCriteria);
        yield handleSearch();
    });
    const onFilterChange = (filters) => {
        registrationHistoryStore.setCurrentFilters(filters);
    };
    const reset = () => {
        registrationHistoryStore.resetRegHistory();
        handleSearch().then();
    };
    (0, react_1.useEffect)(() => {
        if (!(0, lodash_1.isEqual)(registrationHistoryTabStore.lastQueryOnTab, registrationHistoryStore.currentQuery) ||
            !registrationHistoryTabStore.works) {
            handleSearch(registrationHistoryTabStore.pagination).then();
        }
    }, []);
    const fetchType = type === registration_history_tab_name_1.RegistrationHistoryTabName.Pending ? fetch_type_enum_1.FetchType.MLC : fetch_type_enum_1.FetchType.TRANSACTION;
    return (react_1.default.createElement("div", { className: 'registration-history-pending-tab' },
        react_1.default.createElement("section", { className: 'showing-search' },
            react_1.default.createElement("div", { className: 'showing-search-right' }, registrationHistoryStore.criteriaStore && (react_1.default.createElement(SearchWithCriteria_1.default, { searchCriteriaStore: registrationHistoryStore.criteriaStore, canAddCriteria: true, handleSearch: handleSearchWithNewCriteria, disableSearchButtons: loading, resetSearchFn: reset, filterFieldCollections: useFilters ? reg_history_filter_1.RegistrationHistoryFilterCollection : undefined, handleFilterValueChange: useFilters ? onFilterChange : undefined })))),
        loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(WorkResultsTable_1.default, { works: registrationHistoryTabStore.works, fetchType: fetchType, paginationInfo: registrationHistoryTabStore.paginationInfo, limit: registrationHistoryTabStore.limit, onChangePage: onChangePage, onChangeLimit: onChangeLimit, compactWorkComponentType: HistoryCompactWorkItem_1.default, extendedWorkComponentType: HistoryExtendedWorkItem_1.default, compact: !!((_a = userStore.userSettings) === null || _a === void 0 ? void 0 : _a.showDetailedWorkCards), showCompactToggle: true }))));
};
exports.default = (0, mobx_react_1.observer)(RegistrationHistoryTab);
